/* eslint-disable no-undef */
// @flow
import React from 'react'
import UserIdentity from './UserIdentity'
import PasswordChange from './PasswordChange'
import ConnectedServices from './ConnectedServices/index'

export default class UserSettingsForm extends React.Component<{model: Object}> {
  form: ?HTMLFormElement;

  showConfirmPassword = () => {
    if (this.props.model.fromBitbucket() || this.props.model.fromGithub() || this.props.model.fromGitlab()) {
      return false
    }
    return this.props.model.get('password_set')
  }

  submit = () => {
    return this.form && this.form.submit()
  }

  csrfParams = () => {
    const csrfToken = $('meta[name=csrf-token]').attr('content')
    const csrfParam = $('meta[name=csrf-param]').attr('content')
    return {name: csrfParam, value: csrfToken, type: 'hidden'}
  }

  render = () => {
    return (
      <form
        className='user-form'
        action={Routes.profile_path()}
        method='post'
        ref={form => (this.form = form)}
      >
        <input {...this.csrfParams()} />
        <input name='_method' type='hidden' value='put' />
        <div className='form__sidebar-right pull-left'>
          <UserIdentity
            full_name={gon.user.full_name}
            email={gon.user.email}
            errors={gon.user.errors}
            submit={this.submit}
          />
          <PasswordChange
            showConfirmPassword={this.showConfirmPassword()}
            errors={gon.user.errors}
            submit={this.submit}
          />
          <ConnectedServices />
        </div>
      </form>
    )
  }
}

window.Components.UserSettingsForm = React.createFactory(UserSettingsForm)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/userEdit/UserSettingsForm.js